// ppt 前缀为application
const PPT_ACCEPT = [
  'vnd.ms-powerpoint',
  'vnd.openxmlformats-officedocument.presentationml.presentation',
  'ppt',
  'pptx',
]

// pdf 前缀为application
const PDF_ACCEPT = ['pdf']

// 图片
const IMAGE_ACCEPT = ['jpg', 'png', 'jpeg', 'gif']

// 视频
const VIDEO_ACCEPT = ['mp4', 'mov', 'webm', 'mkv']

// 音频
const AUDIO_ACCEPT = ['mp3', 'wav', 'mpeg']

const PAG_ACCEPT = ['pag']

// 字体 前缀为application
const FONT_ACCEPT = ['font-woff', 'otf', 'ttf', 'woff2', 'woff']

enum SOURCE_TYPE {
  PPT = 'ppt',
  PDF = 'pdf',
  FONT = 'font',
  IMAGE = 'image',
  VIDEO = 'video',
  MATERIAL = 'material',
}

enum FILE_SIZE {
  PPT = 200,
  PDF = 100,
  FONT = 20,
  IMAGE = 50,
  VIDEO = 500,
  MUSIC = 10,
  PAG = 30,
}

export {
  SOURCE_TYPE,
  PDF_ACCEPT,
  PPT_ACCEPT,
  IMAGE_ACCEPT,
  VIDEO_ACCEPT,
  FONT_ACCEPT,
  FILE_SIZE,
  AUDIO_ACCEPT,
  PAG_ACCEPT,
}
